import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import 'swiper/css/bundle';

export default () => {

	const els = [...document.querySelectorAll('.related-products')]

	els.map(el => {

		const carouselEl = el.querySelector('.related-products__cont')
		const carouselPrev = el.querySelector('.swiper-navigation__prev')
		const carouselNext = el.querySelector('.swiper-navigation__next')

		if (!carouselEl) return null

		return new Swiper(carouselEl, {
			modules: [ Navigation ],
			speed: 500,
			slidesPerView: 1.3,
			slidesPerGroup: 1,
			loop: true,
			spaceBetween: 16,
            navigation: {
                nextEl: carouselNext,
                prevEl: carouselPrev,
            },
			breakpoints: {
				780: { 
					slidesPerView: 2.3,
				},
				1124: { 
					slidesPerView: 3,
				},
				1350: { 
					slidesPerView: 4,
				},
			},
		})
	})
}